// extracted by mini-css-extract-plugin
export default {"formInputContainer":"FormInput_formInputContainer__Qfbcf"};